module.exports = __webpack_public_path__ + "4346a777cce9167dcdc63dd17dcadc43.svg";